import { FC } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import {
    WorkspaceResourceCollectionSkeleton,
    WorkspaceResourceListSkeleton,
} from '@/shared/components/lists/WorkspaceResourceList';
import { centerComponentInMiddleofView } from '@/utilities/styles/centerInMiddle';

const LoadingContent: FC = (): JSX.Element => {
    const { token } = useAntDesignTheme();
    const pathname = typeof window === 'undefined' ? '' : window.location.pathname;
    const collectionRoute = ['/archive', '/drafts', '/trash'].some((route) => pathname.startsWith(route));
    const listRoute = ['/folders', '/relations/dashboards', '/relations/lists'].some((route) =>
        pathname.startsWith(route),
    );

    if (collectionRoute || listRoute) {
        return (
            <div style={{ backgroundColor: token.colorBgContainer, height: '100%', minHeight: 0, overflow: 'hidden' }}>
                {collectionRoute ? (
                    <WorkspaceResourceCollectionSkeleton sections={4} />
                ) : (
                    <WorkspaceResourceListSkeleton rows={16} />
                )}
            </div>
        );
    }

    return (
        <div
            style={{
                height: '100%',
                minHeight: 0,
                ...centerComponentInMiddleofView,
                backgroundColor: token.colorBgContainer,
            }}
        >
            <span style={{ color: token.colorTextTertiary }}>
                <LoadingOutlined spin style={{ verticalAlign: '-0.15rem', marginRight: '0.75rem' }} />
                Loading...
            </span>
        </div>
    );
};

export default LoadingContent;
